import ApiService from '@/core/services/ApiService';
import { Actions, Mutations } from '@/store/enums/StoreEnums';
import { Module, Action, Mutation, VuexModule } from 'vuex-module-decorators';

export interface QualityRangeObject {
  id: number;
  from: number;
  to: number;
  slug: string;
  sort: null;
  titleEn: string;
  titleAr: string;
  isActive: null;
  title: string;
}

export interface QualityRangesListInfo {
  totalItems: number;
  currentPage: number;
  pageSize: number;
  isNext: boolean;
  previous: number;
  qualityRanges: Array<QualityRangeObject>;
  errors: unknown;
}

@Module
export default class QualityRangesModule
  extends VuexModule
  implements QualityRangesListInfo
{
  qualityRanges = [] as Array<QualityRangeObject>;
  totalItems = 0;
  currentPage = 1;
  pageSize = 10;
  previous = 0;
  isNext = true;
  errors = {};

  /**
   * Get Quality Ranges list
   * @returns Array<QualityRangeObject>
   */
  get qualityRangesList(): Array<QualityRangeObject> {
    return this.qualityRanges;
  }

  /**
   * Get total items
   * @returns number
   */
  get qualityRangesListCount(): number {
    return this.totalItems;
  }

  @Mutation
  [Mutations.SET_QUALITY_RANGES](data) {
    this.qualityRanges = data.data;
    this.totalItems = data.totalItems;
    this.currentPage = data.currentPage;
    this.pageSize = data.pageSize;
    this.isNext = data.isNext;
    this.previous = data.previous;
    this.errors = {};
  }

  @Mutation
  [Mutations.SET_QUALITY_RANGES_CURRENT_PAGE](page) {
    this.currentPage = page;
  }

  @Mutation
  [Mutations.RESET_QUALITY_RANGES_LIST]() {
    this.qualityRanges = [] as Array<QualityRangeObject>;
    this.totalItems = 0;
    this.currentPage = 1;
    this.pageSize = 10;
    this.previous = 0;
    this.isNext = true;
    this.errors = {};
  }

  @Action
  [Actions.CREATE_QUALITY_RANGE](data) {
    ApiService.setAuthorizationHeader();
    return ApiService.post('/ive-fq-ranges', data)
      .then(() => {
        this.context.commit(Mutations.RESET_QUALITY_RANGES_LIST);
      })
      .catch(({ response }) => {
        this.context.commit(Mutations.SET_ERROR, {
          [response.statusText]: [response.data.message],
        });
      });
  }

  @Action
  [Actions.DELETE_QUALITY_RANGE](id) {
    ApiService.setAuthorizationHeader();
    return ApiService.delete('/ive-fq-ranges', id)
      .then(() => {
        this.context.commit(Mutations.RESET_QUALITY_RANGES_LIST);
      })
      .catch(({ response }) => {
        this.context.commit(Mutations.SET_ERROR, {
          [response.statusText]: [response.data.message],
        });
      });
  }

  @Action
  [Actions.UPDATE_QUALITY_RANGE]({ id, data }) {
    ApiService.setAuthorizationHeader();
    return ApiService.update('/ive-fq-ranges', id, data)
      .then(() => {
        this.context.commit(Mutations.RESET_QUALITY_RANGES_LIST);
      })
      .catch(({ response }) => {
        this.context.commit(Mutations.SET_ERROR, {
          [response.statusText]: [response.data.message],
        });
      });
  }

  @Action
  [Actions.UPDATE_QUALITY_RANGE_CURRENT_PAGE](val) {
    this.context.commit(Mutations.SET_QUALITY_RANGES_CURRENT_PAGE, val);
  }

  @Action
  [Actions.GET_QUALITY_RANGE](id) {
    ApiService.setAuthorizationHeader();
    return ApiService.get('/ive-fq-ranges', id);
  }

  @Action
  [Actions.GET_QUALITY_RANGES]() {
    ApiService.setAuthorizationHeader();
    return ApiService.query('/ive-fq-ranges', {
      params: { page: this.currentPage },
    })
      .then(({ data }) => {
        this.context.commit(Mutations.SET_QUALITY_RANGES, data);
      })
      .catch(({ response }) => {
        console.error(response);
        // this.context.commit(Mutations.SET_ERROR, {
        //   [response.statusText]: [response.data.message],
        // });
      });
  }
}
